<template>
  <div>
    <div class="page-header page-header-kyc">
      <div class="container">
        <div class="row justify-content-center"></div>
      </div>
      <!-- .container -->
    </div>
    <!-- .page-header -->
    <div class="page-content">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-10 col-xl-9">
            <div class="kyc-status card mx-lg-4">
              <div class="card-innr">
                <div class="status status-thank px-md-5">
                  <div class="status-icon">
                    <em class="ti ti-check"></em>
                  </div>
                  <span class="status-text large text-dark">You have completed the process of KYC</span>
                  <p
                    class="px-md-5"
                  >We are still waiting for your identity verification. Once our team verified your indentity, you will be able to see your updated KYC details on the dashboard soon</p>
                 
                  <button @click="toHome" v-if="$router.currentRoute.name!=='home'"    class="btn btn-primary">
                 
                 
                  Back to Dashboard</button>
                </div>
              </div>
            </div>
            <!-- .card -->

            <div class="gaps-1x"></div>
            <div class="gaps-3x d-none d-sm-block"></div>
          </div>
        </div>
      </div>
      <!-- .container -->
    </div>
    <!-- .page-content -->
  </div>
</template>
<script>
export default {
  name: "KYCDone",
  methods:{
    toHome(){
        window.location.href=''
    }
  },
  created(){
    this.$store.state.loading=false;
  }
};

</script>
